import React, { useState, useContext, useEffect } from "react";
import Input from "../input/Input";
import { useDispatch, useSelector } from "react-redux";
import { language } from "../../stores/slices/languageSlice";
import { UserContext } from '../../stores/Context/Context'
import { payableToDropdown, payableToDropdownWithInsurance } from "../../constant/Constants";
import validateInput from "../../utilities/validations/validateInput";
import { lookUp } from "../../stores/slices/lookupSlice";
import { toast } from "react-toastify";
import { smartyStreetApi } from "../../stores/slices/smartyStreetSlice";
import { payableToData } from "../../stores/slices/claimIntake/claimIntakeSlice";

function PayableTo() {
  let wizardValidation = useContext(UserContext);
  const [payableToInfo, setPayableToInfo] = useState({
    payableTo: { value: "", isValid: true },
    name: { value: "", isValid: true },
    addressLine1: { value: "", isValid: true },
    addressLine2: { value: "", isValid: true },
    city: { value: "", isValid: true },
    state: { value: "", isValid: true },
    zipCode: { value: "", isValid: true },
    isAddressVerified: false,
    smartyStreetMatches: {
      NoMatch: false,
      PartialMatch: false,
      SecInfoNotMatch: false,
      ExactMatch: false,
    },
    ss_msg_cls: '',
    ss_msg: '',
  })
  const lookUpData = useSelector(lookUp);
  const errorMessage = useSelector(language).errorMessage
  const selectedLanguage = useSelector(language).Claimintake.payableTo;

  const dispatch = useDispatch()
  const prgData = useSelector(state => state.patientSearchSlice.patientInformation.Program)
  const claimUserData = useSelector(state => state.claimProcessSlice)
  const payableTo = useSelector(state => state.claimIntakeSlice.payableTo)

  useEffect(() => {
    setPayableToInfo(payableTo)
  }, [])

  const inputOnChange = (e, fieldvalidation) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = validateInput(inputValue, fieldvalidation);
    if (name == "addressLine1" || name == "addressLine2" || name == "city" || name == "state" || name == "zipCode") {
      setPayableToInfo((prevState) => ({
        ...prevState,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
        isAddressVerified: false,
        smartyStreetMatches: {
          NoMatch: false,
          PartialMatch: false,
          SecInfoNotMatch: false,
          ExactMatch: false,
        },
        ss_msg_cls: '',
        ss_msg: '',
      }))
    } else {
      setPayableToInfo((prevState) => ({
        ...prevState,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
      }))
    }
  }

  const onClickVerifyAddress = () => {
    const validateAddress = payableToInfo.addressLine1.value != "" && payableToInfo.city.value != "" && payableToInfo.state.value != "" && payableToInfo.zipCode.value != "" && payableToInfo.addressLine1.isValid && payableToInfo.addressLine2.isValid && payableToInfo.city.isValid && payableToInfo.state.isValid && payableToInfo.zipCode.isValid
    setPayableToInfo((prevState) => ({
      ...prevState,
      isAddressVerified: validateAddress
    }))
    if (validateAddress) {
      const address = {
        addressLine1: payableToInfo.addressLine1.value,
        addressLine2: payableToInfo.addressLine2.value,
        city: payableToInfo.city.value,
        state: payableToInfo.state.value,
        zipCode: payableToInfo.zipCode.value,
      };
      dispatch(smartyStreetApi({ address, callbackVerifiedAddress }));
    } else {
      toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
      setPayableToInfo((prevState) => ({
        ...prevState,
        addressLine1: {
          value: prevState.addressLine1.value,
          isValid: prevState.addressLine1.isValid && prevState.addressLine1.value != '',
        },
        addressLine2: {
          value: prevState.addressLine2.value,
          isValid: prevState.addressLine2.isValid,
        },
        city: {
          value: prevState.city.value,
          isValid: prevState.city.isValid && prevState.city.value != '',
        },
        state: {
          value: prevState.state.value,
          isValid: prevState.state.isValid && prevState.state.value != '',
        },
        zipCode: {
          value: prevState.zipCode.value,
          isValid: prevState.zipCode.isValid && prevState.zipCode.value != '',
        }
      }));
    }
  }

  const callbackVerifiedAddress = (address) => {
    if (address?.isValidateAddress != undefined && address.isValidateAddress == "ExactMatch") {
      setPayableToInfo((prevState) => ({
        ...prevState,
        addressLine1: {
          value: address.street,
          isValid: prevState.addressLine1.isValid,
        },
        addressLine2: {
          value: address.street2,
          isValid: prevState.addressLine2.isValid,
        },
        city: {
          value: address.city,
          isValid: prevState.city.isValid,
        },
        state: {
          value: address.state,
          isValid: prevState.state.isValid,
        },
        zipCode: {
          value: address.zipcode,
          isValid: prevState.zipCode.isValid,
        },
        smartyStreetMatches: {
          NoMatch: address.NoMatch,
          PartialMatch: address.PartialMatch,
          SecInfoNotMatch: address.SecInfoNotMatch,
          ExactMatch: address.ExactMatch,
        },
        ss_msg_cls: "ss_success",
        ss_msg: errorMessage.smartyStreetMsg.sucessMsg,
        isAddressVerified: true,
      }));

    } else {
      setPayableToInfo((prevState) => ({
        ...prevState,
        addressLine1: {
          value: address.street,
          isValid: prevState.addressLine1.isValid,
        },
        addressLine2: {
          value: address.street2,
          isValid: prevState.addressLine2.isValid,
        },
        city: {
          value: address.city,
          isValid: prevState.city.isValid,
        },
        state: {
          value: address.state,
          isValid: prevState.state.isValid,
        },
        zipCode: {
          value: address.zipcode,
          isValid: prevState.zipCode.isValid,
        },
        smartyStreetMatches: {
          NoMatch: address.NoMatch,
          PartialMatch: address.PartialMatch,
          SecInfoNotMatch: address.SecInfoNotMatch,
          ExactMatch: address.ExactMatch,
        },
        ss_msg_cls: "ss_error",
        ss_msg: errorMessage.smartyStreetMsg.errorMsg,
        isAddressVerified: true,


      }));
    }
  }

  function payableToValidation() {
    if (payableToInfo.payableTo.value != "") {
      if (payableToInfo.payableTo.value == "Other") {
        const isValidPayable = payableToInfo.name.value != "" && payableToInfo.name.isValid
        if (isValidPayable) {
          if (payableToInfo.isAddressVerified) {
            dispatch(payableToData({ payableToInfo, claimUserData }))
            return true
          } else {
            toast.error("Verify address to proceed")
            return false
          }
        } else {
          setPayableToInfo((prevState) => ({
            ...prevState,
            name: {
              value: payableToInfo.name.value,
              isValid: payableToInfo.name.value != "" && payableToInfo.name.isValid,
            },
            addressLine1: {
              value: payableToInfo.addressLine1.value,
              isValid: payableToInfo.addressLine1.value != "" && payableToInfo.addressLine1.isValid,
            },
            addressLine2: {
              value: payableToInfo.addressLine2.value,
              isValid: payableToInfo.addressLine2.isValid,
            },
            city: {
              value: payableToInfo.city.value,
              isValid: payableToInfo.city.value != "" && payableToInfo.city.isValid,
            },
            state: {
              value: payableToInfo.state.value,
              isValid: payableToInfo.state.value != "" && payableToInfo.state.isValid,
            },
            zipCode: {
              value: payableToInfo.zipCode.value,
              isValid: payableToInfo.zipCode.value != "" && payableToInfo.zipCode.isValid,
            },
          }))
          toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
          return false
        }
      } else {
        dispatch(payableToData({ payableToInfo, claimUserData }))
        return true
      }
    } else {
      setPayableToInfo((prevState) => ({
        ...prevState,
        payableTo: {
          value: payableToInfo.payableTo.value,
          isValid: payableToInfo.payableTo.value != "" && payableToInfo.payableTo.isValid,
        },
      }))
      toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
      return false
    }
  }

  wizardValidation.formValidation.isValidate = payableToValidation;
  return (
    <React.Fragment>
      <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8">
        <Input
          type="select"
          id="payableTo"
          label={selectedLanguage.heading}
          name="payableTo"
          value={payableToInfo.payableTo.value}
          isValid={payableToInfo.payableTo.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          elmentconfig={claimUserData.isClaimInsuranceAvailable ? payableToDropdownWithInsurance : payableToDropdown}
        />
        {payableToInfo.payableTo.value != "" && <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-2 mt-5 px-6">
          <i data-feather="file-text"></i>
          <p className="p-1 ps-3 text-theme-1">
            {selectedLanguage.heading}
          </p>
        </div>}
      </div>
      {payableToInfo.payableTo.value == "Patient/Guardian" && <div className="text-justify px-10">
        {/* <p className="fw-medium fs-base mb-5 px-10">{payableToInfo.payableTo.value}</p>
        <p className="px-10 mt-2">{claimUserData.hasGuardian ? (claimUserData.guardianDetails.firstName + " " + claimUserData.guardianDetails.lastName + ",") : claimUserData.patientDetails.fullName + ","}</p>
        <p className="px-10 mt-2">{claimUserData.hasGuardian ? (claimUserData.guardianDetails.addressLine1 + ", " + claimUserData.guardianDetails.addressLine2 + ",") : claimUserData.patientDetails.fullAddressLine + ","}</p>
        <p className="px-10 mt-2">{claimUserData.hasGuardian ? claimUserData.guardianDetails.city + "," : claimUserData.patientDetails.city + ","}</p>
        <p className="px-10 mt-2">{claimUserData.hasGuardian ? (claimUserData.guardianDetails.state + ", " + claimUserData.guardianDetails.zipCode + ", " + "US") : (claimUserData.patientDetails.state + ", " + claimUserData.patientDetails.zipCode + ", " + "US")}</p> */}
        <p className="fw-medium fs-base mb-5 px-10">{payableToInfo.payableTo.value}</p>
        <p className="px-10 mt-2">{claimUserData.hasGuardian ? (claimUserData.guardianDetails.firstName + " " + claimUserData.guardianDetails.lastName + ",") : claimUserData.patientDetails.fullName + ","}</p>
        <p className="px-10 mt-2">{claimUserData.patientDetails.fullAddressLine + ","}</p>
        <p className="px-10 mt-2">{claimUserData.patientDetails.city + ","}</p>
        <p className="px-10 mt-2">{claimUserData.patientDetails.state + ", " + claimUserData.patientDetails.zipCode + ", " + "US"}</p>
      </div>}
      {payableToInfo.payableTo.value == "Provider" && <div className="text-justify px-10">
        <p className="fw-medium fs-base mb-5 px-10">{payableToInfo.payableTo.value}</p>
        <p className="px-10">Claim will be settled to the provider in the supporting document</p>
      </div>}
      {payableToInfo.payableTo.value == "Insurance" && <div className="text-justify px-10">
        <p className="fw-medium fs-base mb-5 px-10">{payableToInfo.payableTo.value}</p>
        <p className="px-10">Claim will be settled to the insurance payor in the supporting document</p>
      </div>}
      {payableToInfo.payableTo.value == "Other" && <div className="text-justify px-10">
        <p className="fw-medium fs-base mb-5 px-10">{payableToInfo.payableTo.value}</p>
        <React.Fragment>
          <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-5">
            <Input
              type="text"
              id="name"
              label={selectedLanguage.name}
              name="name"
              value={payableToInfo.name.value}
              isValid={payableToInfo.name.isValid}
              onChange={(e) => inputOnChange(e, "claimName")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
            />
            <Input
              type="text"
              id="addressLine1"
              label={selectedLanguage.addressLine1}
              name="addressLine1"
              value={payableToInfo.addressLine1.value}
              isValid={payableToInfo.addressLine1.isValid}
              onChange={(e) => inputOnChange(e, "claimAddressLine1")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
            />
            <Input
              type="text"
              id="addressLine2"
              label={selectedLanguage.addressLine2}
              name="addressLine2"
              value={payableToInfo.addressLine2.value}
              isValid={payableToInfo.addressLine2.isValid}
              onChange={(e) => inputOnChange(e, "claimAddressLine2")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
            />
            <Input
              type="text"
              id="city"
              label={selectedLanguage.city}
              name="city"
              value={payableToInfo.city.value}
              isValid={payableToInfo.city.isValid}
              onChange={(e) => inputOnChange(e, "claimCity")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
            />
            <Input
              type="select"
              id="state"
              label={selectedLanguage.state}
              name="state"
              value={payableToInfo.state.value}
              isValid={payableToInfo.state.isValid}
              onChange={(e) => inputOnChange(e, "dropDown")}
              errorMsg={errorMessage?.inputErrorMessage}
              elmentconfig={lookUpData.State}
            />
            <Input
              type="text"
              id="zipCode"
              label={selectedLanguage.zipcode}
              name="zipCode"
              value={payableToInfo.zipCode.value}
              isValid={payableToInfo.zipCode.isValid}
              onChange={(e) => inputOnChange(e, "zipcode")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
            />
          </div>
          <div className={`${payableToInfo.ss_msg_cls} intro-y g-col-12 g-col-md-12 g-col-xl-12 mt-4 text-center`}>
            {payableToInfo.ss_msg}
            <div className="intro-y g-col-12 g-col-sm-12 text-center mt-1"><button className="btn verifyAddres mt-2 ms-2 z-10" data-testid="verifyAddress" onClick={onClickVerifyAddress} >{selectedLanguage.verifyAddress}</button></div>
          </div>
        </React.Fragment>
      </div>}
    </React.Fragment>
  );
}

export default PayableTo;
